module.exports = __webpack_public_path__ + "static/media/respondant_simple_plus.fe16e60e.pdf";